import { useMutation } from "@tanstack/react-query";

import http from "../../../http";
import { GET_SUBSEQUENT_FEE_CALCULATION } from "../../URL";
import { IFeeCalculationRequest } from "../../../interfaces";

interface IFeeResponse {}

interface IAxisErrorResponse {
  response?: {
    data?: {
      allowanceCharge: [];
      messageStatus?: {
        messageContentError: IMessageContentErrorItem[];
      };
    };
  };
}

interface IMessageContentErrorItem {
  errorDescription?: {
    errorCodeDescriptionText?: {
      value?: string;
    };
  };
}

const getSubsequentFeesCalculation = async (filing: IFeeCalculationRequest) => {
  const response = await http.post<IFeeResponse>(
    GET_SUBSEQUENT_FEE_CALCULATION,
    filing
  );

  return response?.data;
};

const useSubsequentFeesCalculation = () =>
  useMutation<any, IAxisErrorResponse, IFeeCalculationRequest>({
    mutationKey: ["subsequent-fee-calculation"],
    mutationFn: getSubsequentFeesCalculation,
  });

export default useSubsequentFeesCalculation;
